require('dotenv').config();
export default {
  siteName: 'Cams Admin',
  siteTitle: 'Cams Admin',
  siteIcon: 'ion-ios-videocam',
  footerText: `Cams Admin Dashboard @ ${new Date().getFullYear()} Created by BALKON`,
  enableAnimatedRoute: false,
  dashboard: '/dashboard',
  apiUrl: 'https://qa-dashboardapi.qa.cams.run/'
};